import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {compose} from 'recompose';
import {Button, withStyles} from "@material-ui/core";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import SelectFilter from "./SelectFilter";
import Search from "./Search";
import t from "../../languages/pl";
import ActionCreator from './../../store/actions/index';
import {baseCarsSearchByFilters} from "../../utils/helpers";
import CachedIcon from "@material-ui/icons/Cached";
import {TooltipTop as CustomTooltip} from "../Common/CustomTooltips";

const useStyles = () => ({
    filterParametersRow: {
        display: "flex"
    }
});

/**
 * Filter component
 * Prop attributes:
 *  - List of cars to be filtered
 *  - Callback which returns the list of cars after it has been changed
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */

const SimpleCarsFilter = props => {
    const {
        classes,
        fullCarsList,
        groupOptions, brandOptions, allModelsOptions, fuelTypeOptions,
        onChangeFilter
    } = props;

    const [queryText, setQueryText] = useState('');
    const [queryGroup, setQueryGroup] = useState('');
    const [queryBrand, setQueryBrand] = useState('');
    const [queryModel, setQueryModel] = useState('');
    const [queryFuel, setQueryFuel] = useState('');

    const [queryModelOptions, setQueryModelOptions] = useState([]);


    const setQueryBrandHandler = (val) => {
        setQueryBrand(val);
        setQueryModelOptions(val ? allModelsOptions.filter(m => m.marka_id === val.id) : []);
    };

    const performQuery = () => {
        const newCars = baseCarsSearchByFilters(fullCarsList, queryText, queryGroup.id, queryBrand.id, queryModel.id, queryFuel.id);
        onChangeFilter(newCars);
    };

    const handleResetClick = () => {
        setQueryText('');
        setQueryGroup('');
        setQueryBrand('');
        setQueryModel('');
        setQueryFuel('');
    };

    useEffect(() => {
        performQuery();
    }, [queryText, queryGroup, queryBrand, queryModel, queryFuel]);

    return (
        <div className={classes.filterParametersRow}>
            <Search
                searchValue={queryText}
                onSearchFieldChange={(value) => setQueryText(value)}
                disableSelect
            />
            <SelectFilter
                label={t.pickGroup}
                options={groupOptions}
                value={queryGroup}
                onChange={(e) => setQueryGroup(e)}
            />
            <SelectFilter
                label={t.brand}
                options={brandOptions}
                value={queryBrand}
                onChange={(e) => setQueryBrandHandler(e)}
            />
            <SelectFilter
                label={t.model}
                options={queryModelOptions}
                value={queryModel}
                onChange={(e) => setQueryModel(e)}
            />
            <SelectFilter
                label={t.fuel}
                options={fuelTypeOptions}
                value={queryFuel}
                onChange={(e) => setQueryFuel(e)}
            />

            <CustomTooltip title={t.resetFilters}>
                <Button
                    style={{minWidth: 30}}
                    onClick={handleResetClick}
                >
                    <CachedIcon/>
                </Button>
            </CustomTooltip>
        </div>
    );
};

const mapStateToProps = (state) => ({
    fullCarsList: state.carsReducer.cars,
    groupOptions: state.filterReducer.groupOptions,
    brandOptions: state.filterReducer.brandOptions,
    allModelsOptions: state.filterReducer.allModelOptions,
    fuelTypeOptions: state.filterReducer.fuelTypeOptions,
});

const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActionCreator, dispatch);
};


SimpleCarsFilter.propTypes = {
    classes: PropTypes.object,
    fullCarsList: PropTypes.array,
    groupOptions: PropTypes.array,
    brandOptions: PropTypes.array,
    allModelsOptions: PropTypes.array,
    fuelTypeOptions: PropTypes.array,
    onChangeFilter: PropTypes.func,
};

export default compose(withStyles(useStyles), connect(
    mapStateToProps,
    mapDispatchToProps
))(SimpleCarsFilter);
